import React from 'react';
import { withFormulas } from '../hocs/with-formulas';
import { ScoreContent, ScoreSubcomponents } from '../components';


export const ScoreCashFlow = ({formulas, className}) => {
  const costTitle = "Cash Flow";
  const costSummary = "Understanding cash flow can help determine the effectiveness of your collection efforts and the overall efficiency of your revenue-to-cash cycle, as well as provide indicators for future health."
  const getStarted = () => {
    window.open('https://www.paystand.com/ar-health-consult','_blank','resizable=yes');
  }
  return (
    <ScoreContent title={costTitle} summary={costSummary} className={className}>
      <div className="print--only-visible">
        <img src={require(`../../styles/img/${formulas.getCashFlowScore()}_score.png`)} style={{width: "55px"}} alt="score-a"/>
      </div>
      <div className="health-graph">
        <ScoreSubcomponents title="DSO" health={formulas.getDsoHealth()}/>
        <ScoreSubcomponents title="Late receivables benchmark" health={formulas.getReceivablesBenchmarkHealth()}/>
        <ScoreSubcomponents title="First-time vs. returning customers" health={formulas.getReturningCustomersHealth()}/>
      </div>
      <div className="info">
        <span className="text-02-navy-blue">Recommended Reading</span>
        <p className="text-04-navy-blue-bold">Here are some helpful resources for creating more efficient and predictable cash flow.</p>
        <a className="text-04-sky-blue" href="https://www.paystand.com/blog/understanding-accounts-receivable-management" target="_blank" rel="noopener noreferrer">
          Quick Guide to Understanding Accounts Receivable Management
        </a>
        <a className="text-04-sky-blue" href="https://www.paystand.com/blog/getting-paid-on-time-and-improving-cash-flow" target="_blank" rel="noopener noreferrer">
          A Strategy to Steady Cash Flow
        </a>
        <a  className="text-04-sky-blue" href="https://www.paystand.com/blog/benefits-automated-payment-solutions" target="_blank" rel="noopener noreferrer">
          How Automated Payments Can Enhance Your Business
        </a>
        <span className="text-02-navy-blue-bold">Ready to speed up time-to-cash and automate payments?</span>
        <button onClick={getStarted}>Get Started</button>
      </div>
    </ScoreContent>
  )
}

export const ScoreCashFlowWithFormulas = withFormulas(ScoreCashFlow);